<template>
  <v-container fluid>

    <!-- ตัวเลือกกรอง -->
    <div class="d-flex align-center mb-4">
      <v-radio-group v-model="filterStatus" row>
        <v-radio label="All" value="ALL"></v-radio>
        <v-radio label="Active" value="ACTIVE"></v-radio>
        <v-radio label="Inactive" value="INACTIVE"></v-radio>
      </v-radio-group>

      <v-spacer></v-spacer>

      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        dense
        hide-details
        style="max-width: 250px"
      ></v-text-field>
    </div>

    <!-- Card list -->
    <v-row dense>
      <v-col cols="12" md="3" v-for="a in filteredAnalyzers" :key="a.id">
        <v-card class="pa-4 analyzer-card" @click="openDetail(a)">
          <div class="d-flex align-center">
            <v-img :src="a.img" width="40" height="40" contain class="mr-3" />
            <div>
              <div class="font-weight-bold">{{ a.name }}</div>
              <div style="font-size: 12px; color: #777">{{ a.type }}</div>
            </div>
            <v-spacer></v-spacer>
            <v-chip x-small dark :color="chipColor(a.status)">
              {{ a.status }}
            </v-chip>
          </div>

          <div class="mt-3">
            <div style="font-size: 12px; color: #777">Samples Processed</div>
            <div style="font-size: 16px; font-weight: 600">{{ a.samples }}</div>
          </div>

          <div class="mt-2">
            <span style="font-size: 12px; color:#777">
              {{ a.protocol === 'RS232' ? 'Port' : 'IP Address' }}
            </span>
            <div style="font-weight: 500">
              {{ a.protocol === 'RS232' ? a.comPort : (a.ip + ':' + a.port) }}
            </div>
          </div>
        </v-card>
      </v-col>
    </v-row>

    <!-- Drawer แสดงรายละเอียดเครื่อง -->
    <v-navigation-drawer right temporary v-model="detailDrawer" width="400">
      <v-card flat class="pa-4">

        <div class="font-weight-bold mb-2" style="font-size: 18px">
          {{ selected?.name }}
        </div>

        <div class="mb-4" style="color: #777">{{ selected?.type }}</div>

        <v-divider class="my-3" />

        <div v-if="selected">
          <div class="mb-2">
            <strong>Status:</strong> {{ selected.status }}
          </div>
          <div class="mb-2">
            <strong>Samples:</strong> {{ selected.samples }}
          </div>
          <div class="mb-2">
            <strong>Protocol:</strong> {{ selected.protocol }}
          </div>
          <div class="mb-2">
            <strong>IP / Port:</strong>
            {{ selected.ip }} : {{ selected.port }}
          </div>
        </div>

      </v-card>
    </v-navigation-drawer>

  </v-container>
</template>

<script>
export default {
  name: 'MonitorDetail',
  data () {
    return {
      search: '',
      filterStatus: 'ALL',
      detailDrawer: false,
      selected: null,
      analyzers: [] // --> load API จริงใส่ตรงนี้
    }
  },
  computed: {
    filteredAnalyzers () {
      let list = [...this.analyzers]

      // filter status
      if (this.filterStatus === 'ACTIVE') {
        list = list.filter(a => a.status === 'Online')
      } else if (this.filterStatus === 'INACTIVE') {
        list = list.filter(a => a.status === 'Offline')
      }

      // search
      if (this.search) {
        const s = this.search.toLowerCase()
        list = list.filter(a =>
          a.name.toLowerCase().includes(s) ||
          a.type.toLowerCase().includes(s)
        )
      }

      return list
    }
  },
  methods: {
    chipColor (status) {
      return status === 'Online' ? 'green' : 'red'
    },
    openDetail (item) {
      this.selected = item
      this.detailDrawer = true
    }
  }
}
</script>

<style scoped>
.analyzer-card {
  cursor: pointer;
  border-radius: 10px;
  transition: 0.2s;
}
.analyzer-card:hover {
  background: #f8f9fb;
}
</style>
